<template>
  <layout-content>
    <i-button slot="top-buttons" size="large" type="primary" @click="create_operators">
      {{ $t('autocaller_v2.operators.button.create') }}
    </i-button>
    <filter-component />
    <table-component />
  </layout-content>
</template>
<script>
  import TableComponent from '@autocaller_v2/components/operators-table.vue';
  import FilterComponent from '@autocaller_v2/components/operators-table-filter.vue';
  import { OperatorsModalService } from '@autocaller_v2/modals/OperatorsModalService';
  import { mapActions } from 'vuex';
  export default {
    components: { 
      TableComponent,
      FilterComponent
    },
    methods: {
      ...mapActions('autocaller_v2/operators/table', ['getAsyncData']),
      create_operators: function() {
        OperatorsModalService.create().on('success', () => this.getAsyncData());
      }
    }
  };
</script>
